import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { LANDING } from 'constants/testIds';

const CHAPTERS = [
  {
    no: '01',
    word: 'Create',
    body: 'Publish work, spin up projects, and build a living portfolio that grows with your craft — from first shoot to signature style.',
  },
  {
    no: '02',
    word: 'Connect',
    body: 'Follow the makers you admire, get discovered by brands, and turn a feed of noise into a room full of the right people.',
  },
  {
    no: '03',
    word: 'Collaborate',
    body: 'Ideate, credit, and ship together. Bring a team onto a brief and make the work that moves your whole industry forward.',
  },
];

const Chapter = ({ c, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'start center'],
  });
  const x = useTransform(scrollYProgress, [0, 1], [index % 2 ? 40 : -40, 0]);
  const opacity = useTransform(scrollYProgress, [0, 1], [0.15, 1]);

  return (
    <motion.div
      ref={ref}
      data-testid={LANDING.manifestoChapter(c.no)}
      style={{ opacity }}
      className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-baseline border-t border-zinc-800 py-12 md:py-16"
    >
      <div className="md:col-span-2">
        <span className="font-display text-sm font-semibold tracking-[0.3em] text-[#6C63F5]">
          {c.no}
        </span>
      </div>

      <motion.h3
        style={{ x }}
        className="md:col-span-6 font-display font-bold text-5xl sm:text-6xl md:text-[3.75rem] lg:text-[7rem] leading-[0.85] tracking-tighter text-zinc-50"
      >
        {c.word}
        <span className="text-[#6C63F5]">.</span>
      </motion.h3>

      <p className="md:col-span-4 text-zinc-400 text-base md:text-lg leading-relaxed md:pt-4">
        {c.body}
      </p>
    </motion.div>
  );
};

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid={LANDING.manifestoSection}
      className="relative py-24 md:py-40 bg-zinc-950 overflow-hidden"
    >
      <div className="absolute inset-0 grid-lines opacity-30" aria-hidden />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#6C63F5] font-medium mb-5">
            The Qreativs way
          </div>
          <h2 className="font-display font-bold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-zinc-50">
            Three moves. One creative life.
          </h2>
        </div>

        <div>
          {CHAPTERS.map((c, i) => (
            <Chapter key={c.no} c={c} index={i} />
          ))}
          <div className="border-t border-zinc-800" />
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
